import "./Sidebar.scoped.scss";

import React from "react";

import clsx from "clsx";

import useSiteStructure from "core/custom-hooks/useSiteStructure";
import useStore from "core/custom-hooks/useStore";

import SidebarHeader from "./SidebarHeader/SidebarHeader";
import SidebarSection from "./SidebarSection/SidebarSection";
import SidebarAdminBusinessSelection from "./SidebarAdminBusinessSelection/SidebarAdminBusinessSelection";

const Sidebar = () => {
    const { state } = useStore();
    const { isAdmin, isMobile } = state;
    const { getSiteStructure } = useSiteStructure();
    const siteStructure = getSiteStructure();

    if (isMobile) return null;
    return (
        <div className="side_bar_area">
            <div className="side_bar_wrap">
                <SidebarAdminBusinessSelection />
                <div className={clsx("side_bar_max", isAdmin && "side_bar_max_admin", "on_scrolling")}>
                    <SidebarHeader />
                    <div className="side_bar_menu_wrap ">
                        <ul className="side_bar_menu_list">
                            {
                                siteStructure
                                    .map((x, index) => <SidebarSection key={`Sidebar_SidebarSection_${index}`} {...x} />)
                            }
                        </ul>
                    </div>
                    <div className="side_bar_footer">
                        <a href="https://img.zapgroup.co.il/PrivacyPolicy.pdf" target="_blank" rel="noopener noreferrer">
                            מדיניות הפרטיות
                        </a>
                        <a href="https://zapgroup.co.il/terms/" target="_blank" rel="noopener noreferrer">
                            תנאי שימוש
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Sidebar;